<template>
  <form class="pdf-modal main-form" v-if="mutatedServices">
    <div class="pdf-modal__form">
      <div class="main-form__box main-form__box_relative">
        <label class="main-form__label">Nach dem Kundennamen suchen</label>
        <input
          type="text"
          class="main-form__input"
          v-model="form.search"
          placeholder="Nach dem Kundennamen suchen"
          @input="searchClient"
          @blur="onSearchBlur"
          autocomplete="false"
        />

        <label
          class="user-autocomplete"
          ref="user-autocomplete"
          :style="{
            'z-index': isSearching ? 1 : -1,
          }"
        >
          <div
            class="user-autocomplete__option"
            v-for="item in clients"
            :key="item.id"
            @click="chooseClient(item)"
          >
            <p>{{ item.first_name }} {{ item.last_name }}</p>
          </div>
        </label>
      </div>

      <div class="main-form__box main-form__box_flex">
        <div class="main-form__half main-form__half_first-pr12">
          <label class="main-form__label">{{ $t("forms.client") }}</label>
          <input
            type="text"
            class="main-form__input"
            v-model="form.contact.name"
            @input="changeSpanText('contact_name_span', $event)"
            :placeholder="$t('forms.client')"
          />
        </div>

        <div class="main-form__half main-form__half_first-pl12">
          <label class="main-form__label">{{ $t("forms.phone") }}</label>
          <input
            type="text"
            class="main-form__input"
            v-model="form.contact.phone"
            :placeholder="$t('forms.phone')"
          />
        </div>
      </div>

      <div class="main-form__box main-form__box_flex">
        <div class="main-form__half main-form__half_first-pr12">
          <label class="main-form__label">E-mail</label>
          <input
            type="text"
            class="main-form__input"
            v-model="form.contact.email"
            placeholder="E-mail"
          />
        </div>

        <div class="main-form__half main-form__half_first-pl12">
          <label class="main-form__label">Addresse</label>
          <input
            type="text"
            class="main-form__input"
            v-model="form.contact.address"
            placeholder="Addresse"
          />
        </div>
      </div>

      <div class="main-form__box">
        <label class="main-form__label">{{ $t("listsHeader.service") }}</label>
        <Select2
          v-validate="'required'"
          data-vv-as="field"
          name="services"
          :options="mutatedServices"
          :settings="selectSettingServices"
          v-model="form.service_id"
          class="select2-container_w100"
          @change="changeService"
        />
      </div>

      <div class="main-form__box">
        <label class="main-form__label">Niederlassung</label>

        <Select2
          v-model="form.office_id"
          :options="filteredList"
          class="select select2-container_w100"
          :settings="selectSetting"
          placeholder="Niederlassung"
          @change="changeOffice"
        />
      </div>

      <div class="main-form__box main-form__box_flex">
        <div
          class="main-form__half main-form__half_first-pr12 hide-datepicer-icon"
        >
          <div>
            <label class="main-form__label">{{ $t("listsHeader.date") }}</label>
          </div>
          <el-date-picker
            style="width:100%"
            class="multiple-days multiple-days_one"
            v-model="form.should_started_at"
            type="date"
            :placeholder="$t('request.dateHolder')"
            default-time="12:00:00"
            :pickerOptions="pickerOptions"
            ref="datetime-picker-day"
            effect="dark"
          ></el-date-picker>
        </div>
        <div
          class="main-form__half main-form__half_first-pl12 hide-datepicer-icon"
        >
          <div>
            <label class="main-form__label">Dauer</label>
          </div>
          <el-time-select
            class="application-time-picker application-time-picker_w150"
            v-model="duration"
            :picker-options="{
              start: '00:30',
              end: '10:00',
              step: '00:15',
            }"
            placeholder="00:30"
            :editable="false"
            style="width:100%"
          ></el-time-select>
        </div>
      </div>

      <div class="main-form__box main-form__box_flex mb20">
        <div class="main-form__half main-form__half_first-pr12">
          <label class="main-form__label"
            >Preis (Leistung * Meistermenge)</label
          >
          <input
            type="text"
            class="main-form__input"
            v-model.lazy="mutatedRecomendedFinalPrice"
            placeholder="Preis"
          />
        </div>

        <div
          class="main-form__half main-form__half_first-pl12 main-form__half_rel hide-datepicer-icon"
          v-if="mutatedMaterials"
        >
          <label class="main-form__label">Materialien</label>

          <multiselect
            v-model="form.materials"
            :options="mutatedMaterials"
            :multiple="true"
            label="text"
            track-by="text"
            :placeholder="'Materialien'"
          />
        </div>
      </div>

      <div class="main-form__box" v-if="form.materials.length > 0">
        <div
          class="main-layout__item"
          v-for="(item, index) in form.materials"
          :key="item.id"
        >
          <p class="w-3">{{ index + 1 }}.</p>
          <p class="w-18">{{ item.text }}</p>
          <p class="w-10">€ {{ item.price }}</p>
          <p class="w-20">
            <input
              style="text-align: center;width: 50px;background-color: transparent !important;color: var(--menu-text-color);border: 1px solid var(--border-color);border-radius: 4px;outline:none"
              type="text"
              v-model="item.count"
            />
          </p>
          <p class="w-10">€ {{ item.price * item.count }}</p>
        </div>
      </div>

      <div
        class="application-box application-employee mt26"
        :class="{
          'application-box_full': large,
        }"
      >
        <div class="application-box__title application-box__title_flex">
          {{ $t("request.responsible") }}
          <svg
            style="cursor:pointer"
            @click="showResponsible"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7.5" stroke="var(--menu-text-color)" />
            <path
              d="M8.00012 4.66669V11.3334"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M11.3332 8H4.6665"
              stroke="var(--menu-text-color)"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>

        <div class="application-employee__block" v-bar>
          <div class="application-employee__list">
            <div
              class="application-employee__item"
              v-for="user in form.executors"
              :key="user.id"
            >
              <div
                class="application-employee__item-remove"
                @click="removeResponsible(user.id)"
              >
                <img src="/images/icon/remove.svg" alt />
              </div>
              <div
                class="application-employee__item-img"
                :style="{ backgroundImage: getImageURL(user.small_image) }"
              ></div>
              <div
                class="application-employee__item-name"
                :title="user.first_name + ' ' + user.last_name"
              >
                {{ user.first_name }}
                {{ user.last_name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="main-form__box main-form__box_flex mt16">
        <button
          class="main-button"
          type="reset"
          @click="generateFile"
          style="border-radius:4px !important"
          :disabled="isSubmitted"
        >
          Generieren
        </button>
        <!-- <button
          type="reset"
          class="main-button main-button_w160 ml12"
          style="max-width: 227px;width: 210px !important;border-radius:4px !important"
          @click="generateFileWithEmail"
          :disabled="isSubmitted"
        >
          Generieren und an E-Mail senden
        </button> -->
      </div>
    </div>

    <div class="pdf-modal__content">
      <section class="container-fluid pb-4" ref="html">
        <div class="row justify-content-center align-self-center mt-5">
          <div class="col-12">
            <div class="row">
              <div class="col-9 float-left">
                <img
                  v-if="isHilfy"
                  src="https://api.hilfy.at/img/logo-hilfy.png"
                  alt
                  width="184px"
                  height="84px"
                />
                <img
                  v-else
                  src="https://api.hilfy.at/img/logo-profy.png"
                  alt
                  width="184px"
                  height="84px"
                />
              </div>
              <div class="col-3 float-right" v-if="isHilfy">
                <div>Hilfy GmbH</div>
                <div>Ihr Allround-Handwerker</div>
                <div>0800 297921</div>
                <div>info@hilfy.at</div>
              </div>

              <div class="col-3 float-right" v-else>
                <div>Hilfy GmbH</div>
                <div>Kaiserswertherstrasse. 135</div>
                <div>40476 Düsseldorf</div>
                <div>0211-97537177</div>
                <div>Info@hilfy.eu</div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table border-0">
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <h3 class="text-center">Arbeitsschein</h3>
                  </td>
                </tr>
              </table>
            </div>

            <div class="row mb-3">
              <div class="col-4 offset-8 float-right">
                <div>Datum: {{ convertDate(form.should_started_at) }}</div>
                <div>
                  <template v-if="form.executors.length > 0">
                    <p
                      class="mb-0"
                      v-for="(master, index) in form.executors"
                      :key="master.id"
                    >
                      <span v-if="index === 0">Monteur:</span>
                      {{ master.first_name }} {{ master.last_name }}
                    </p>
                  </template>
                  <template v-else>
                    <p>Monteur:</p>
                  </template>
                </div>
              </div>
            </div>

            <div class="table-responsive">
              <table class="table border-0">
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <b>Leistungen:</b>
                    {{ form.service }}
                  </td>
                </tr>
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <b>Name:</b>
                    <span>{{ form.contact.name }}</span>
                  </td>
                  <td class="border-0 pl-0 pt-1">
                    <b>Tel.:</b>
                    <span>{{ form.contact.phone }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-0 pl-0 pt-1">
                    <b>Adresse:</b>
                    <span>{{ form.contact.address }}</span>
                  </td>
                  <td class="border-0 pl-0 pt-1">
                    <b>E-mail:</b>
                    <span>{{ form.contact.email }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="border-0 pl-0 pt-1" colspan="2">
                    <b>Abweichende Lieferadresse:</b>
                    <span>{{ form.contact.address }}</span>
                  </td>
                </tr>
              </table>
            </div>

            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th style="border: 1px solid #000000"></th>
                    <th style="border: 1px solid #000000" width="15%">
                      Stunden
                    </th>
                    <th style="border: 1px solid #000000" width="15%">Stück</th>
                    <th style="border: 1px solid #000000" width="15%">
                      Einzelpreis
                    </th>
                    <th style="border: 1px solid #000000" width="15%">
                      Gesamt
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <td style="border: 1px solid #000000">Arbeitszeit</td>
                    <td style="border: 1px solid #000000">
                      <span v-if="finalPrice != 0">{{ form.price.time }}</span>
                    </td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000">
                      <span v-if="service.price != 0"
                        >€ {{ getPrice(servicePrice) }}</span
                      >
                    </td>
                    <td style="border: 1px solid #000000">
                      <span v-if="service.price != 0"
                        >€ {{ getPrice(servicePrice) }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td style="border: 1px solid #000000">Anfahrt</td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000">
                      <span v-if="finalPrice != 0">1</span>
                    </td>
                    <td style="border: 1px solid #000000">
                      <template v-if="service.price != 0">
                        <span v-if="form.price.trip"
                          >€ {{ getPrice(form.price.trip) }}</span
                        >
                      </template>
                    </td>
                    <td style="border: 1px solid #000000">
                      <template v-if="service.price != 0">
                        <span v-if="form.price.trip"
                          >€ {{ getPrice(form.price.trip) }}</span
                        >
                      </template>
                    </td>
                  </tr>

                  <tr v-for="item in form.materials" :key="item.id">
                    <td style="border: 1px solid #000000">{{ item.text }}</td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000">
                      <span>{{ item.count }}</span>
                    </td>
                    <td style="border: 1px solid #000000">
                      <span>€ {{ getPrice(item.price) }}</span>
                    </td>
                    <td style="border: 1px solid #000000">
                      <span>€ {{ getPrice(item.price * item.count) }}</span>
                    </td>
                  </tr>

                  <tr style="height:40px">
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                  </tr>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                  </tr>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                  </tr>
                  <tr style="height:40px">
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                    <td style="border: 1px solid #000000"></td>
                  </tr>

                  <tr>
                    <td style="border: 1px solid #000000" colspan="4">
                      Gesamtsumme in Euro (brutto)
                    </td>
                    <td style="border: 1px solid #000000">
                      <span v-if="form.price.trip && finalPrice != 0"
                        >€ {{ getPrice(finalPrice) }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="table-responsive">
              <table class="table border-0">
                <tr>
                  <td class="border-0 col-8">
                    <ul class="small">
                      <li>Barzahlung</li>
                      <li>Bankomat</li>
                      <li>Kreditkarte</li>
                      <li>
                        Überweisung; unter Angabe der Rechnungsnummer, binnen 14
                        Tagen ohne Abzug!
                      </li>
                    </ul>
                  </td>
                  <td
                    class="text-left align-middle border-0 col-4"
                    style="display:block;width:100%"
                  >
                    Unterschrift:
                  </td>
                </tr>
              </table>
            </div>

            <div class="row mt-3" v-if="isHilfy">
              <div class="col" style="line-height: 1rem">
                <span class="small">
                  Es gelten unsere AGB-siehe, www.hilfy.at, 1010 Wien,
                  Rosenbursenstraße 2/21
                  <br />Die eingetragenen Daten sind vom Besteller oder seinem
                  Beauftragten zu prüfen und die Richtigkeit der Eintragungen
                  durch Unterschrift zu bestätigen. <br />Eventuelle
                  Abweichungen sind sofort auf dem Arbeitsschein zu vermerken.
                  <br />Arbeitsscheine dienen als Berechnungsgrundlage.
                  Gerichtsstand Wien. UID-Nr.: ATU 75207223; FB Nr.: FN 488463 d
                  <br />Raiffeisenlandesbank Wien, IBAN: AT59 3200 0000 1308
                  2672; BIC: RLNWATWW.
                </span>
              </div>
            </div>
            <div class="row mt-3" v-else>
              <div class="col" style="line-height: 1rem">
                <span class="small">
                  Es gelten unsere AGB-siehe, "getprofy.de"
                  <br />Die eingetragenen Daten sind von Besteller oder seinem
                  Beauftragten zu prüfen und die Richtigkeit der Eintragungen
                  durch Unterschrift zu bestätigen. <br />Eventuelle
                  Abweichungen sind sofort auf dem Arbeitsschein zu vermerken.
                  <br />Arbeitsscheine dienen als Berechnungsgrundlage,
                  Gerichtstand Düsseldorf, USt - IdNr: (VAT) DE333291445;
                  <br />HR Nr.: HRB 90459 solarisBank AG, IBAN: DE31 1101 0100
                  2848 6852 17; BIC: SOBKDEBBXXX
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <modal
      :show="isShowResponsible"
      :dark="true"
      @close="closeResponsibleModal"
    >
      <add-responsible-for-pdf
        :responsibleData="form.executors"
        :hide="false"
        :tags="[]"
        @close="closeResponsibleModal"
        @confirm="confirmResponsible"
      ></add-responsible-for-pdf>
    </modal>
  </form>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import date from '@/mixins/date'
import utf8_to_b64 from '@/utils/utf8_to_b64'
import recomendedPrice from '@/mixins/recomendedPrice'
import rounded from '@/utils/rounded'
import formatPrice from '@/utils/formatPrice'

export default {
    name: 'actAcceptance',
    mixins: [date, recomendedPrice],
    data() {
        return {
            isSearching: true,
            selectSettingServices: {
                placeholder: this.$t('navigation.services'),
                allowClear: false,
            },
            mutatedServices: null,
            defaultImage: '/images/default-user.svg',
            isShowResponsible: false,
            duration: '01:00',
            service: {},
            mutatedMaterials: null,
            selectSetting: {
                placeholder: 'Niederlassung',
            },
            isSubmitted: false,
        }
    },
    computed: {
        ...mapGetters({
            clients: 'clientsData',
            services: 'servicesFullData',
            form: 'pdf/pdf',
            materials: 'materials/getMaterials',
            filteredList: 'offices/filteredList',
        }),
        pickerOptions() {
            return {
                firstDayOfWeek: 1,
                selectableRange: ['00:00:00 - 23:00:00'],
                // disabledDate(time) {
                //   const from = new Date();

                //   // disable if day is saturday or sunday
                //   if (time.getDay() == 6 || time.getDay() == 0) {
                //     return true;
                //   }

                //   return time.getTime() < from.getTime() - 8.64e7;
                // },
            }
        },
        isHilfy() {
            return this.$config.behavior === 'hilfy'
        },
        mutatedRecomendedFinalPrice: {
            get() {
                return this.recomendedFinalPrice
            },
            set(v) {
                this.setPriceByKey('_15', 0)
                this.setPriceByKey('hours', parseFloat(!!v === false ? 1 : v))
                this.setPriceByKey('recomended', 1)
                this.setPriceByKey(
                    'executorsQuantity',
                    this.form.executors.length || 1,
                )
            },
        },
        servicePrice() {
            return this.mutatedRecomendedFinalPrice - this.form.price.trip
        },
        finalPrice() {
            const sum = this.form.materials.reduce(
                (accum, item) => (item.price * item.count),
                0,
            )

            return +this.mutatedRecomendedFinalPrice + sum
        },
    },
    methods: {
        ...mapActions({
            getClientsData: 'getClientsData',
            generate: 'pdf/generate',
            sendEmail: 'pdf/sendEmail',
            fetchMaterials: 'materials/fetch',
        }),
        ...mapMutations({
            setClientsData: 'clientsData',
            clearMaterials: 'materials/clear',
        }),
        pressButton() {
            this.isSubmitted = true
        },
        changeOffice() {
            this.mutatedServices.find(
                (item) => item.id === this.form.service_id,
            )

            const office = this.service.office_prices.find(
                (item) => item.id === this.form.office_id,
            )

            this.setOffice(office)
        },
        setOffice(officeAttr) {
            const office = officeAttr ?? {
                prices: {
                    price: 0,
                    price_fifteen: 0,
                },
            }

            this.service = { ...this.service, ...office.prices }
            this.setPriceByKey('hours', office.prices.price)
            this.setPriceByKey(
                '_15',
                this.getPriceFromDuration({
                    price_fifteen: office.prices.price_fifteen,
                    price: office.prices.price,
                }),
            )
            this.setPriceByKey('executorsQuantity', this.form.executors.length || 1)
        },
        getPrice(price) {
            return formatPrice(rounded(price))
        },
        getMaterials() {
            this.clearMaterials()
            this.fetchMaterials({ id: this.service.id, page: 'materials' }).then(
                () => {
                    this.mutatedMaterials = this.materials.map((material) => ({
                        price: material.price,
                        text: material.name.original,
                        count: 1,
                        id: material.id,
                    }))
                },
            )
        },
        changeMaterialCount(id, event) {
            const count = +event.target.textContent

            this.form.materials = this.form.materials.map((material) => {
                if (material.id === id) {
                    material.count = count
                    return material
                } else return material
            })
        },
        closeResponsibleModal() {
            this.isShowResponsible = false
        },
        getImageURL(image) {
            return `url(${image === null ? this.defaultImage : image}`
        },
        showResponsible() {
            this.isShowResponsible = true
        },
        removeResponsible(id) {
            this.form.executors = this.form.executors.filter((item) => item.id !== id)

            this.setPriceByKey('executorsQuantity', this.form.executors.length)
        },
        confirmResponsible() {
            this.setPriceByKey('executorsQuantity', this.form.executors.length)
        },
        searchClient() {
            this.getClientsData({ word: this.form.search })
            this.isSearching = true
        },
        chooseClient(client) {
            this.form.contact.name = `${client.first_name} ${client.last_name}`
            this.form.contact.first_name = client.first_name
            this.form.contact.last_name = client.last_name
            this.form.contact.email = client.email
            this.form.contact.phone = client.phone
            this.form.contact.id = client.id

            this.form.search = this.form.contact.name

            if (client.addresses[0]) {
                this.form.contact.address = `${client.addresses[0].street}, ${client.addresses[0].house}, ${client.addresses[0].apartment}, ${client.addresses[0].country}, ${client.addresses[0].city}`
                const address = client.addresses[0]
                this.form.address = address
            }
            if (client.office) {
                this.form.office_id = client.office.id
            }

            this.isSearching = false
        },
        onSpanInput(e, { target }) {
            const [a, b] = e.split('.')

            this.form[a][b] = target.textContent || ''
        },
        changeSpanText(ref, { target: { value } }) {
            this.$refs[ref].textContent = value
        },
        onBlur() {
            this.isSearching = false
        },
        getHtml() {
            const html = this.$refs.html.innerHTML
            return utf8_to_b64(html)
        },
        getClient() {
            return this.form.contact.name !== '' ? this.form.contact : null
        },
        prepareForm() {
            return {
                type: 'act-acceptance',
                client: this.getClient(),
                data: {
                    ...this.form,
                    total: `${this.finalPrice}`,
                    contract_number: 1,
                    totalNoVat: `${this.finalPrice}`,
                    mutatedRecomendedFinalPrice: this.mutatedRecomendedFinalPrice,
                },
                total: `${this.finalPrice}`,
                html: this.getHtml(),
            }
        },
        notify() {
            this.$notify({
                title: 'PDF generiert',
                message: 'Sie haben erfolgreich eine PDF-Datei generiert',
                duration: 5000,
            })
        },
        async generateFile() {
            this.pressButton()
            const form = this.prepareForm()
            const response = await this.generate(form)
            const isOkey = response.status === 201

            if (!isOkey) return

            this.notify()
            this.$emit('done')
        },
        async generateFileWithEmail() {
            this.pressButton()
            const form = this.prepareForm()
            const response = await this.generate(form)
            const isOkey = response.status === 201

            if (!isOkey) return

            this.notify()
            this.$emit('done')

            await this.sendEmail({
                id: response.data.id,
                email: form.data.contact.email,
            })
        },
        onSearchBlur() {
            if (this.form.search) return
            this.isSearching = false
        },
        getPriceFromDuration(data) {
            const priceFifteen = data.price_fifteen
            const value = this.duration || '01:00'
            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes
            return ((sum - 60) / 15) * priceFifteen
        },
        changeService() {
            this.service = this.services.find(
                (item) => item.id === this.form.service_id,
            )

            this.form.service = this.service.title

            if (this.form.office_id) {
                const office = this.service.office_prices.find(
                    (item) => item.id === this.form.office_id,
                )
                this.setOffice(office)
            } else {
                this.setOffice(this.service.office_prices[0])
            }

            this.getMaterials()
        },
    },
    watch: {
        duration(value) {
            const priceFifteen = this.service.price_fifteen

            const hours = Number(value.split(':')[0]) * 60
            const minutes = Number(value.split(':')[1])
            const sum = hours + minutes

            const result = ((sum - 60) / 15) * priceFifteen
            this.form.price.time = value
            this.setPriceByKey('_15', result)
            this.setPriceByKey('executorsQuantity', this.form.executors.length || 1)
        },
    },
    async beforeMount() {
        this.setClientsData({ data: null })

        if (!this.services[0]) return

        this.mutatedServices = this.services.map((service) => ({
            id: service.id,
            text: service.title,
        }))

        this.service = this.form.service_id
            ? this.services.find((item) => item.id === this.form.service_id)
            : this.services[0]
        const office = this.service.office_prices.find(
            (item) => item.id === this.form.office_id,
        )
        this.setOffice(office)

        // this.fetchMaterials({ id: this.service.id }).then(() => {
        //   this.mutatedMaterials = this.materials.map((material) => ({
        //     price: material.price,
        //     text: material.name.short,
        //     count: 1,
        //   }));
        // });
        this.getMaterials()

        this.duration = this.form.price.time
    },
    beforeDestroy() {
        this.setClientsData({ data: null })
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/_bootstrap.min.scss";

.pdf-modal .row {
  border-bottom: unset !important;
  height: unset !important;
}

.pdf-modal {
  line-height: 1.5 !important;
}

@media print {
  .new-page {
    page-break-before: always !important;
  }
}

ul {
  list-style-type: circle !important;
}
</style>
